import { NELO_VISIT_ID_COOKIE, VISIT_ID_MAX_AGE_SECONDS } from "@/platform/api/constants"
import { uuidv7 } from "@/platform/api/uuidv7"
import { readCookie, setCookie } from "@/platform/browser/cookies"

export const visitIdClient = (): string => {
  if (typeof window === "undefined") return ""

  const id = readCookie(NELO_VISIT_ID_COOKIE) ?? uuidv7()
  setCookie(NELO_VISIT_ID_COOKIE, id, { maxAgeSeconds: VISIT_ID_MAX_AGE_SECONDS, sameSite: "Lax" })

  return id
}
